module.exports = __webpack_public_path__ + "assets/img/projects_item3.e93ccb86.jpg";